import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import styled from 'styled-components';
import { useAiAssistant } from '../../AiAssistantContext';
import SessionView from './SessionView';
import FileView from './FileView';

const TabContent: React.FC = () => {
  const { state } = useAiAssistant();

  if (state.tabs.length === 0) {
    return (
      <EmptyState>
        <EmptyIcon>
          <FontAwesomeIcon icon={faMicrochip} />
        </EmptyIcon>
        <EmptyTitle>AI Assistant</EmptyTitle>
        <EmptyText>
          {state.selectedProjectId
            ? 'Click [+] next to Sessions in the sidebar to start a new chat, or open a file.'
            : 'Select a project from the sidebar to get started.'}
        </EmptyText>
      </EmptyState>
    );
  }

  return (
    <TabPaneContainer>
      {state.tabs.map((tab) => (
        <TabPane key={tab.id} $active={tab.id === state.activeTabId}>
          {tab.type === 'session' && tab.sessionId && (
            <SessionView sessionId={tab.sessionId} isActive={tab.id === state.activeTabId} />
          )}
          {tab.type === 'file' && tab.filePath && (
            <FileView path={tab.filePath} />
          )}
        </TabPane>
      ))}
    </TabPaneContainer>
  );
};

export default TabContent;

const TabPaneContainer = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
`;

const TabPane = styled.div<{ $active: boolean }>`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  visibility: ${(p) => (p.$active ? 'visible' : 'hidden')};
  z-index: ${(p) => (p.$active ? 1 : 0)};
`;

const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  gap: 8px;
`;

const EmptyIcon = styled.div`
  font-size: 36px;
  color: #ccc;
  margin-bottom: 4px;
`;

const EmptyTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #888;
`;

const EmptyText = styled.div`
  font-size: 14px;
  color: #aaa;
  max-width: 320px;
  text-align: center;
  line-height: 1.5;
`;
